import React from 'react';
import { Ambient } from '../Ambient';
import { Eyebrow, Reveal } from '../Reveal';
interface Layer {
  title: string;
  detail?: string;
  emphasis?: boolean;
}
const LAYERS: Layer[] = [{
  title: 'Telecom Integration & Real-Time Voice',
  detail: 'Carrier · SIP · PSTN'
}, {
  title: 'Conversational Orchestration & Intelligence',
  detail: 'Routing · Reasoning'
}, {
  title: 'Context • Memory • Business Logic • Backend',
  detail: 'Stateful'
}, {
  title: 'Self-Hosted AI Models',
  detail: 'LLM • STT • TTS',
  emphasis: true
}, {
  title: 'Vexu-Controlled Infrastructure',
  detail: 'Compute · Data'
}];
const ADVANTAGES = ['Data Control', 'Low Latency', 'Cost Control', 'Scalability', 'Deployment Flexibility', 'Reduced Vendor Dependency'];
const VERTICALS = ['Vexu AI', 'Vexu Portal', 'Talab'];
function Connector() {
  return <div className="flex h-[16px] justify-center" data-id="element-667" data-mp="1gbw7u97c7oec">
      <div className="w-px bg-gradient-to-b from-slate-200 via-slate-400 to-slate-200" data-id="element-668" data-mp="1gdgz9pycur7z" />
    </div>;
}
export function TechnologySlide() {
  return <section className="relative h-full w-full" data-id="element-669" data-mp="1m8pmgbf72qao">
      <Ambient variant="default" grid data-id="element-670" data-mp="1ma0r0dggs22u" />

      <div className="relative flex h-full flex-col px-[96px] pb-[54px] pt-[62px]" data-id="element-671" data-mp="2087f51vm2npb">
        <Reveal delay={0} data-id="element-672" data-mp="1w6dlhdju2jyn">
          <Eyebrow data-id="element-673" data-mp="1w75gam5lwdnv">The Vexu Technology</Eyebrow>
          <h2 className="mt-[14px] text-[40px] font-semibold tracking-[-0.03em] text-slate-900" data-id="element-674" data-mp="1w49j501l1t0h">
            The Technology Behind Vexu
          </h2>
        </Reveal>

        <div className="mt-[42px] flex flex-1 gap-[48px]" data-id="element-675" data-mp="13izvjzejyoo1">
          {/* Narrative column */}
          <div className="flex w-[352px] flex-col pt-[8px]" data-id="element-676" data-mp="1h9mtvqgeicjl">
            <Reveal delay={0.1} data-id="element-677" data-mp="1chl9ticzrhj0">
              <p className="text-[26px] font-medium leading-[1.32] tracking-[-0.02em] text-slate-900" data-id="element-678" data-mp="1chbjfto1b8cs">
                Vexu owns and operates the full conversational AI technology
                stack.
              </p>
            </Reveal>
            <Reveal delay={0.18} data-id="element-679" data-mp="kp4bdhmlh4a0">
              <p className="mt-[22px] text-[14.5px] font-light leading-[1.7] text-slate-500" data-id="element-680" data-mp="2jwgw7yi4c0ui">
                We don&rsquo;t rely on third-party AI APIs to deliver our core
                service — giving Vexu greater control over data, latency,
                economics and scale.
              </p>
            </Reveal>
            <Reveal delay={0.26} data-id="element-681" data-mp="2yja3cghhi0bm">
              <div className="mt-[26px] border-l-2 border-vexu/50 pl-[16px]" data-id="element-682" data-mp="2ymfrntiagy6a">
                <p className="text-[13px] font-light leading-[1.65] text-slate-400" data-id="element-683" data-mp="20ynswv3l1owl">
                  Built on open-source foundation models —{' '}
                  <span className="text-slate-700" data-id="element-684" data-mp="2auhet536yur1">
                    hosted, operated, optimized and controlled
                  </span>{' '}
                  entirely within Vexu infrastructure.
                </p>
              </div>
            </Reveal>

            <div className="flex-1" data-id="element-685" data-mp="3mca3q8usaiph" />

            <Reveal delay={0.5} data-id="element-686" data-mp="3r8r17tnvi9f8">
              <p className="text-[13px] font-semibold uppercase leading-[1.7] tracking-[0.26em] text-vexu-600" data-id="element-687" data-mp="3r7xuutsttlxm">
                One Core Technology.
                <br data-id="element-688" data-mp="1amu86ybf83rh" />
                Three Verticals.
              </p>
            </Reveal>
          </div>

          {/* Architecture stack */}
          <div className="relative flex-1" data-id="element-689" data-mp="15usvjbaccb0x">
            {/* Proprietary bracket */}
            <Reveal delay={0.44} className="absolute left-0 top-[64px] flex h-[280px] items-center gap-[10px]" y={0} data-id="element-690" data-mp="10vzi1iv20k0r">
              <span className="whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.26em] text-slate-400 [writing-mode:vertical-rl] [transform:rotate(180deg)]" data-id="element-691" data-mp="rwkrkjew09g9">
                Proprietary Vexu Technology
              </span>
              <div className="h-full w-px bg-gradient-to-b from-transparent via-vexu/50 to-transparent" data-id="element-692" data-mp="hzgdl6v73kaj" />
            </Reveal>

            <div className="mx-auto w-[560px]" data-id="element-693" data-mp="2h96f43y2a4b5">
              {/* Core */}
              <Reveal delay={0.12} data-id="element-694" data-mp="2ccph8i128bkv">
                <div className="relative mx-auto flex h-[54px] w-[290px] items-center justify-center rounded-full border border-vexu/40 bg-white shadow-[0_10px_30px_-10px_rgba(0,200,83,0.45)]" data-id="element-695" data-mp="2cacy41jkfv68">
                  <div className="absolute inset-0 rounded-full bg-vexu/15 blur-2xl" data-id="element-696" data-mp="1dy0pe8gh8p23" />
                  <span className="relative text-[14px] font-semibold uppercase tracking-[0.28em] text-slate-900" data-id="element-697" data-mp="102olpbkcfo91">
                    Vexu AI Core
                  </span>
                </div>
              </Reveal>

              <Connector data-id="element-698" data-mp="v1hbz6yn4ezq" />

              {LAYERS.map((layer, index) => <React.Fragment key={layer.title} data-id="element-699" data-mp="v2sivfndu2v2" data-mpi={index}>
                  <Reveal delay={0.18 + index * 0.06} data-id="element-700" data-mp="havqrblprsyo">
                    <div className={`relative flex h-[58px] items-center justify-between rounded-xl border px-[22px] ${layer.emphasis ? 'border-vexu/45 bg-vexu/[0.07] shadow-[0_10px_28px_-14px_rgba(0,200,83,0.55)]' : 'border-slate-900/[0.08] bg-white/85 shadow-[0_1px_2px_rgba(15,23,42,0.04)]'}`} data-id="element-701" data-mp="h7zvxw55xkeg">
                      {layer.emphasis && <span className="absolute -top-[9px] left-[20px] rounded-full bg-vexu-600 px-[9px] py-[2px] text-[9px] font-bold uppercase tracking-[0.18em] text-white" data-id="element-702" data-mp="3kutiv2togz2x">
                          Self-Hosted
                        </span>}
                      <span className={`text-[16px] tracking-[-0.01em] ${layer.emphasis ? 'font-semibold text-slate-900' : 'font-medium text-slate-700'}`} data-id="element-703" data-mp="bn0nv04sm65u">
                        {layer.title}
                      </span>
                      {layer.detail && <span className={`text-[11px] font-medium uppercase tracking-[0.16em] ${layer.emphasis ? 'text-vexu-600' : 'text-slate-400'}`} data-id="element-704" data-mp="vckvi79598ca">
                          {layer.detail}
                        </span>}
                    </div>
                  </Reveal>
                  {index < LAYERS.length - 1 && <Connector data-id="element-705" data-mp="1c52iq6g5q72q" />}
                </React.Fragment>)}

              {/* Branch into verticals */}
              <Reveal delay={0.54} data-id="element-706" data-mp="1h4x825kaaolo">
                <div className="mt-[2px] flex justify-center" data-id="element-707" data-mp="1h3m8khxvg30d">
                  <div className="h-[26px] w-px bg-slate-300" data-id="element-708" data-mp="1l4zaigxufm20" />
                </div>
                <div className="relative mx-[64px] h-px bg-slate-300" data-id="element-709" data-mp="1q4bxr2smmv54">
                  <div className="absolute left-0 top-0 h-[16px] w-px bg-slate-300" data-id="element-710" data-mp="1q30ur5709rf2" />
                  <div className="absolute left-1/2 top-0 h-[16px] w-px bg-slate-300" data-id="element-711" data-mp="1v1u9f0y13ogt" />
                  <div className="absolute right-0 top-0 h-[16px] w-px bg-slate-300" data-id="element-712" data-mp="3rxrsaaru4u5d" />
                </div>
                <div className="mt-[16px] flex justify-between px-[10px]" data-id="element-713" data-mp="q5nufxaknng">
                  {VERTICALS.map(vertical => <span key={vertical} className="w-[150px] rounded-lg border border-slate-900/[0.08] bg-white py-[10px] text-center text-[13px] font-medium tracking-[-0.01em] text-slate-800 shadow-[0_1px_2px_rgba(15,23,42,0.04)]" data-id="element-714" data-mp="3kl2971ovy0hw">
                      {vertical}
                    </span>)}
                </div>
              </Reveal>
            </div>
          </div>

          {/* Strategic advantages */}
          <div className="w-[228px] pt-[8px]" data-id="element-715" data-mp="272qe44u5gvg">
            <Reveal delay={0.3} data-id="element-716" data-mp="25rne6j7sd5e">
              <span className="block text-[10px] font-semibold uppercase tracking-[0.26em] text-slate-400" data-id="element-717" data-mp="295ozck20ibs">
                Strategic Advantage
              </span>
            </Reveal>
            <div className="mt-[20px] border-l border-slate-900/[0.08] pl-[18px]" data-id="element-718" data-mp="2myldg0vsvuy9">
              {ADVANTAGES.map((advantage, index) => <Reveal key={advantage} delay={0.34 + index * 0.05} data-id="element-719" data-mp="37mmax3xdu8jp" data-mpi={index}>
                  <div className="relative flex items-center gap-[10px] py-[11px]" data-id="element-720" data-mp="37oficlftkwsr">
                    <span className="absolute -left-[22px] h-[5px] w-[5px] rounded-full bg-vexu shadow-[0_0_8px_rgba(0,200,83,0.6)]" data-id="element-721" data-mp="3cn0gmfbih6ek" />
                    <span className="text-[14px] font-light leading-tight tracking-[-0.01em] text-slate-700" data-id="element-722" data-mp="32n9pmnm5t9j8">
                      {advantage}
                    </span>
                  </div>
                </Reveal>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}